import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useReducer } from "@wordpress/element";
import { reducer } from "../reducers/modal-reducer";
const initialState = {
    taskModalOpen: false,
    targetStageId: "",
    taskToEdit: null,
    stageModalOpen: false,
    stageToEdit: null,
    targetPipelineId: "",
    pipelineModalOpen: false,
    newPipelineModalOpen: false,
    pipelineToEdit: null,
    archiveTaskModalOpen: false,
    archiveModalTask: null,
    userModalOpen: false,
    userToEdit: null,
    userSettingsModalOpen: false,
};
const ModalContext = createContext({
    state: initialState,
    modalDispatch: () => { },
});
const ModalContextProvider = ({ children }) => {
    const [state, modalDispatch] = useReducer(reducer, initialState);
    return (_jsx(ModalContext.Provider, { value: { state, modalDispatch }, children: children }));
};
export { initialState, ModalContext, ModalContextProvider, };
